import { useEffect, useState } from "react";
import Select from 'react-select';
import { ddStyles } from "../utils/CommonStyles.js";

let analyticsOptions = [];

function UserAnalyticsTableRow({ index, analyticsNames, handleSubmit, setError, t, setAdd, oddIdx }) {
	const [analyticsLoaded, setAnalyticsLoaded] = useState(false);
	const [analyticsSelected, setAnalyticsSelected] = useState({ name: "analyticsKey", label: "", value: 0 });
	const [isSubmit, setIsSubmit] = useState(false);

	useEffect(() => {
		setAnalyticsValues(analyticsNames);
	}, []);

	function setAnalyticsValues(analyticsObj) {
		let analyticsValue = {};
		analyticsOptions = [];
		if (analyticsObj && analyticsObj.length > 0) {
			analyticsObj.map((aAnalytics, idx) => {

				analyticsValue.label = aAnalytics.analyticsDescription;
				analyticsValue.value = aAnalytics.analyticsKey;
				analyticsOptions.push(analyticsValue);
				if (idx == 0) {
					setAnalyticsSelected({ ...analyticsSelected, label: (analyticsValue.label), value: aAnalytics.analyticsKey });
				}
				analyticsValue = {};
			});
			setAnalyticsLoaded(true);
		}
	}
	const analyticsHandler = (selectedOption, action) => {
		let analyticsKey = selectedOption ? selectedOption.value : 0;
		let analyticsLabel = selectedOption ? selectedOption.label : "";
		setAnalyticsSelected({ ...analyticsSelected, label: (analyticsLabel), value: analyticsKey });
	}

	function submitComplete() {
		setIsSubmit(false);
	}
	
	function submitRow() {
		setError("");
		setIsSubmit(true);
		let initialValues = {
			analyticsKey: analyticsSelected.value,
		};

		if (!analyticsSelected.value || analyticsSelected.value === 0) {
			setError(t("error.analyticsNameReqd"));
			setIsSubmit(false);
		} else {
			handleSubmit(1, initialValues, submitComplete);
		}

	}
	function submitCancel() {
		setError("");
		setAdd(false);
	}
	return (
		<tr key={index}>
			<td className={oddIdx ? "list-td col odd" : "list-td col even"}>
				{analyticsLoaded ? <Select
					name="analyticsKey"
					options={analyticsOptions}
					onChange={analyticsHandler}
					placeholder={""}
					value={analyticsSelected}
					isSearchable={true}
					isClearable={true}
					className="myselect"
					inputId="appSurveyKey-input"
					styles={ddStyles}
				/>
				: <></>}
			</td>
			<td className={oddIdx ? "list-td col odd" : "list-td col even"}>{t("page.active")}</td>
			<td className={oddIdx ? "list-td col odd" : "list-td col even"}>
				<div id="submit-spinner"
					className={isSubmit ? "spinner-border spinner-border-sm text-dark spinner-size" : "spinner-hide"}
				>
				</div>
				{(analyticsOptions && analyticsOptions.length > 0) ?
					(<button className={isSubmit ? "btn btn-primary btn-block me-4 mb-1 pe-none" : "btn btn-primary btn-block me-4 mb-1"} onClick={() => (submitRow())}>{t("page.submit")}</button>)
					:
					(<></>)
				}
				<button className={isSubmit ? "btn btn-primary btn-block me-4 mb-1 pe-none" : "btn btn-primary btn-block me-4 mb-1"} onClick={() => (submitCancel())}>{t("page.cancel")}</button>
			</td>
		</tr>
	)

}
export default UserAnalyticsTableRow;